import { Badge, Card } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { Lazada, Shopee, Tokopedia } from "../../assets/img";
import Marketplace from "../../components/User/Marketplace";
import { getDataTrouserById } from "../../config/Redux/action";

const DetailTrouser = () => {
  let { Id } = useParams();
  const dispatch = useDispatch();
  let [trouser, setTrouser] = useState({});
  const [sizes, setSizes] = useState([]);
  const [benefit, setBenefit] = useState([
    {
      id: '',
      benefit: '',
    },
  ]);
  const discount = parseInt(trouser.promoPrice);

  useEffect(() => {
    const getDataById = async (Id) => {
    const res = await getDataTrouserById(Id);
      setTrouser({ ...res });
      setBenefit(res.benefit);
      ArraySize(res.size);
    };
    getDataById(Id);
  }, [Id, dispatch]);

  const ArraySize = (res) => {
    let data = [];
    // eslint-disable-next-line array-callback-return
    Object.keys(res).map((key) => {
      data.push({
        size: key,
        res: res[key],
      });
    });
    setSizes(data);
  };

  return (
    <div id='detail'>
      <Card
        data-aos='zoom-out'
        className='card-detail'
        title={<h1>Detail Produk</h1>}
      >
        <div className='box'>
          <img
            src={trouser.image_url}
            width={350}
            height={350}
            alt='Gambar Produk'
          />
          <table className='info'>
            <tr>
              <th>Nama : </th>
              <td>{trouser.name}</td>
            </tr>
            <tr>
              <th>Jenis Produk : </th>
              <td>{trouser.kind}</td>
            </tr>
            <tr>
              <th>Stock : </th>
              <td>{trouser.stock} buah</td>
            </tr>
            <tr>
              <th>Harga : </th>
              <td>Rp. {discount.toLocaleString('id-ID')}</td>
            </tr>
            <tr>
              <th>Size : </th>
              <td>
                {sizes
                  .filter((size) => size.res === true)
                  .map((res) => {
                    return (
                      <Badge
                        key={res.id}
                        status='success'
                        text={
                          <span
                            style={{ marginLeft: '-4px', fontSize: '18px' }}
                          >
                            {res.size}
                          </span>
                        }
                        style={{ paddingRight: '10px' }}
                      />
                    );
                  })}
              </td>
            </tr>
          </table>
        </div>
        <section className='desc'>
          <h2>Deskirpsi Produk</h2>
          <p>{trouser.desc}</p>
        </section>
      </Card>
      <section className='benefit'>
        <Card data-aos='zoom-out' title={<h2>Keunggulan Produk</h2>}>
          <ol>
            {benefit.map((res) => (
              <li>{res.benefit}</li>
            ))}
          </ol>
        </Card>
      </section>
      <section className='marketplace'>
        <h1 style={{ padding: '0 5%' }} data-aos='fade-right'>
          Pesan Segara, klik Marketplace dibawah ini
        </h1>
        <div className='content'>
          <a href={trouser.tokopedia} target='_blank' rel='noopener noreferrer'>
            <Marketplace title='Instagram' image={Tokopedia} />
          </a>
          <a href={trouser.shopee} target='_blank' rel='noopener noreferrer'>
            <Marketplace delay={700} title='Shopee' image={Shopee} />
          </a>
          <a href={trouser.lazada} target='_blank' rel='noopener noreferrer'>
            <Marketplace delay={900} title='Lazada' image={Lazada} />
          </a>
        </div>
      </section>
    </div>
  );
};

export default DetailTrouser
